<div class="block request-information">
  <div class="line">
    <div>
      <p>ÁREA</p>
      <p>{{ viewModel?.area }}</p>
    </div>

    <div>
      <p>TIPO</p>
      <p>{{ viewModel?.type }}</p>
    </div>

    <div>
      <p>SUB-TIPO</p>
      <p>{{ viewModel?.subType }}</p>
    </div>
  </div>

  <div class="line">
    <div>
      <p>CPE</p>
      <p>{{ viewModel?.cpe }}</p>
    </div>

    <div *ngIf="viewModel?.billingDate">
      <p>DATA DE FATURAÇÃO</p>
      <p>{{ viewModel.billingDate }}</p>
    </div>

    <div>
      <p>DESCRIÇÃO</p>
      <app-read-more [text]="viewModel?.description" size="200"></app-read-more>
    </div>
  </div>

  <div class="attachments-wrapper" *ngIf="viewModel?.attachments?.length > 0">
    <div class="attachment-item" *ngFor="let item of viewModel?.attachments">
      <app-download-attachment [viewModel]="item" (clickItem)="clickAttachment(item)"> </app-download-attachment>
    </div>
  </div>
</div>
